export default {
	auth: {
		token: null,
		rtoken:"",
	},
	isAuth: false,
	error: false,
	loader: false
}